import React from 'react'
import Translation from '../Translation/cont/Translation'
import TranslationTime from '../Translation/cont/TranslationTime'

function statusClass(screening) {
    if (screening.isNow)  return 'now'
    if (screening.isSoon) return 'soon'
    if (screening.isPast) return 'past'
    return ''
}

class TheatreGroup extends React.Component {
    render() {
        const { theatre, isOpen, onToggle } = this.props

        const nowScreening  = theatre.screenings.find(s => s.isNow)
        const soonScreening = !nowScreening && theatre.screenings.find(s => s.isSoon)
        const nextScreening = !nowScreening && !soonScreening && theatre.screenings.find(s => !s.isPast)

        const statusPill = nowScreening
            ? <span className="db-sc-pill db-sc-pill--now"><Translation id="dashboard_today_now_playing">Now playing</Translation></span>
            : soonScreening
                ? <span className="db-sc-pill db-sc-pill--soon"><Translation id="dashboard_today_soon">Soon</Translation></span>
                : null

        const nextBadge = nextScreening
            ? <span className="db-theatre-next text-regular">{nextScreening.time}</span>
            : null

        return (
            <div className={`db-theatre-group${isOpen ? ' db-theatre-group--open' : ''}`}>
                <div className="db-theatre-header" onClick={onToggle}>
                    <span className="db-theatre-name text-regular">{theatre.name}</span>
                    <div className="db-theatre-header-right">
                        {statusPill || nextBadge}
                        <span className="db-theatre-count text-small-light">{theatre.screenings.length}</span>
                        <span className="db-theatre-chevron text-small-light">{isOpen ? '▲' : '▾'}</span>
                    </div>
                </div>
                <div className="db-theatre-bar">
                    {theatre.segments.map((seg, i) => (
                        <div key={i} className={`db-sb db-sb--${seg}`} />
                    ))}
                </div>
                {isOpen && (
                    <div className="db-theatre-body">
                        {theatre.screenings.map(s => {
                            const cls = statusClass(s)
                            return (
                                <div key={s.id} className={`db-screening${cls ? ` db-screening--${cls}` : ''}`}>
                                    <div className="db-sc-time text-regular">{s.time}</div>
                                    <div className="db-sc-film text-light">{s.film}</div>
                                    {cls === 'now'  && <span className="db-sc-pill db-sc-pill--now text-xsmall-light"><Translation id="dashboard_today_now_playing">Now playing</Translation></span>}
                                    {cls === 'soon' && <span className="db-sc-pill db-sc-pill--soon text-xsmall-light"><Translation id="dashboard_today_soon">Soon</Translation></span>}
                                    {!cls && s.duration && <div className="db-sc-dur text-small-light">{s.duration}<Translation id="movie_attributes_length_unit" before=' '/></div>}
                                </div>
                            )
                        })}
                    </div>
                )}
            </div>
        )
    }
}

class DashboardMoviesToday extends React.Component {
    render() {
        const {
            theatres,
            performancesCount,
            moviesCount,
            currentDateTimestamp,
            openTheatres,
            onToggleTheatre,
            cinemaFilterOptions,
            selectedCinemaId,
            onSelectCinema,
        } = this.props

        return (
            <div className="db-today-sidebar">
                <div className="db-today-topbar">
                    <div className="db-hs-cell">
                        <span className="db-hs-val text-small-regular">{performancesCount}</span>
                        <span className="db-hs-lbl text-xsmall-light"><Translation id="dashboard_stat_performances_label">Performances</Translation></span>
                    </div>
                    <div className="db-hs-cell">
                        <span className="db-hs-val text-small-regular">{moviesCount}</span>
                        <span className="db-hs-lbl text-xsmall-light"><Translation id="dashboard_panel_movies_count">Movies</Translation></span>
                    </div>
                </div>
                {cinemaFilterOptions && cinemaFilterOptions.length > 0 && (
                    <div className="db-cinema-filter">
                        {cinemaFilterOptions.map(c => (
                            <button
                                key={c.id}
                                type="button"
                                className={`db-cinema-filter-btn${c.id === selectedCinemaId ? ' db-cinema-filter-btn--active' : ''}`}
                                onClick={() => onSelectCinema(c.id)}
                            >
                                {c.nameShort}
                            </button>
                        ))}
                    </div>
                )}
                <div className="db-today-header">
                    <span className="db-today-title title-large-light"><Translation id="dashboard_today_title">Today in Cinema</Translation></span>
                    <span className="db-today-date text-small-light">
                        <TranslationTime id="dateWithDay" timeString={currentDateTimestamp} />
                        {' · '}
                        <TranslationTime id="time" timeString={currentDateTimestamp} />
                    </span>
                </div>
                <div className="db-today-scroll">
                    {theatres.map(theatre => (
                        <TheatreGroup
                            key={theatre.id}
                            theatre={theatre}
                            isOpen={openTheatres && (openTheatres.has ? openTheatres.has(theatre.id) : openTheatres.includes(theatre.id))}
                            onToggle={() => onToggleTheatre(theatre.id)}
                        />
                    ))}
                </div>
            </div>
        )
    }
}

export default DashboardMoviesToday
